export const SEARCHTYPES = {
  ALL_DATA: { id: 0, formatName: 'LESSONS.SEARCHTYPE_ALL_DATA' },
  BASE_DATA: { id: 1, formatName: 'LESSONS.SEARCHTYPE_BASE_DATA' },
  TITLE: { id: 2, formatName: 'LESSONS.SEARCHTYPE_TITLE' },
  TAGS: { id: 3, formatName: 'LESSONS.SEARCHTYPE_TAGS' },
};
